module.exports = __webpack_public_path__ + "img/8.a3c60f16.jpg";